import { useNavigate } from "react-router-dom";
import { useFetchTeams } from "../../../api/hooks";
import i18n from "../../../i18n";
import PageContainer from "../../../uikit/PageContainer/PageContainer";
import TeamsGrid from "../components/TeamsGrid";

export default function TeamsPage() {
  const { data: teams } = useFetchTeams();
  const navigate = useNavigate();

  const handleClickTeam = (teamId: string) => {
    navigate(`/teams/${teamId}`);
  };
  
  return (
    <PageContainer
      title={i18n.t("navigation:teams:title")}
      subTitle={i18n.t("navigation:teams:subTitle")}
    >
      <TeamsGrid teams={teams?.map((team) => ({
        id: team.id,
        name: team.fields.long_name,
        location: team.fields.location,
        imageUrl: team.fields.team_cover?.[0]?.url || "",
        logoUrl: team.fields.logo?.[0]?.url || "",
        websiteUrl: team.fields.website_url,
      })) || []} onClickTeam={handleClickTeam} />
    </PageContainer>
  );
}
